import { useTranslation } from 'react-i18next';
import { DoughnutPlaceholderCard } from './DoughnutPlaceholderCard';

export const DoughnutSelectUserCard = ({
  multipleAccountSelected,
}: {
  multipleAccountSelected?: boolean;
}) => {
  const { t } = useTranslation();
  return (
    <DoughnutPlaceholderCard
      placeholder={
        multipleAccountSelected
          ? t('dashboard.placeholders.selectSingleAccount')
          : t('dashboard.placeholders.selectAccount')
      }
    />
  );
};
